const BACKEND_URI = ``;
const API_PATH = "/api";

export default {
    BACKEND_URI,
    API_PATH,
};



// WEBPACK FOOTER //
// ./src/services/config.ts